import { IRouteObject } from "models/RouteInterface";
import { useTranslation } from "react-i18next";
import { getCardTypeTitles } from "services/user/user.session.service";


//export const LocalRoutes: IRouteObject[] = [
export function LocalRoutes() {
  // Private path
  const [t] = useTranslation("header");

  return [
    {
      path: "/my-profile",
      description: "PrivateHome",
      private: true,
      showHeader: true,
    },
    {
      path: "/payment-methods",
      description: "Métodos de pago",
      private: true,
      showHeader: true,
      breadcrumbList: [
        { name: t('breadcrumb.myProfile'), href: "/my-profile" },
        { name: t('breadcrumb.myCards'), href: "/cards-titles" },
        { name: t('breadcrumb.paymentMethods'), href: "/payment-methods" },
      ],
    },
    {
      path: "/personal-data",
      description: "PersonalData",
      private: true,
      showHeader: true,
      breadcrumbList: [
        { name: t('breadcrumb.myProfile'), href: "/my-profile" },
        { name: t('breadcrumb.personalData'), href: "/personal-data" },
      ],
    },
    {
      path: "/plan",
      description: "Planificador",
      private: true,
      showHeader: true,
    },
    {
      path: "/resume-route",
      description: "Pantalla de resumen pago",
      private: true,
      showHeader: true,
    },
    {
      path: "/my-trips",
      description: "Pantalla Mis Viajes",
      private: true,
      showHeader: true,
    },
    {
      path: "/my-past-trips",
      description: "Mis viajes anteriores",
      private: true,
      showHeader: true,
    },
    {
      path: "/ave-stepper-page",
      description: "Ave Flow",
      private: true,
      showHeader: true,
    },
    {
      path: "/on-boarding-ATC",
      description: "Flujo de OnBoarding ATC",
      private: true,
      showHeader: true,
    },
    {
      path: "/test/components",
      description: "ComponentsView",
      private: true,
      showHeader: true,
    },
    // Pubblic path
    {
      path: "/",
      description: "Home",
      private: false,
      showHeader: true,
    },
    {
      path: "/login",
      description: "inicio session",
      private: false,
      showHeader: true,
    },
    {
      path: "/register-user",
      description: "Flujo de registro",
      private: false,
      showHeader: true,
      exitInternalPathBack: "/",
    },
    {
      path: "/on-boarding",
      description: "Flujo de OnBoarding",
      private: false,
      showHeader: true,
    },
    {
      path: "/reset-password",
      description: "Flujo de Recuperación de contraseña",
      private: false,
      showHeader: true,
    },
    {
      path: "/contact-form",
      description: "Formulario de contacto",
      private: false,
      showHeader: true,
    },
    {
      path: "/newsletter",
      description: "Newsletter",
      private: false,
      showHeader: true,
    },
    {
      path: "/delete-account",
      description: "Flujo de borrar cuenta",
      private: false,
      showHeader: true,
      exitInternalPathBack: "/personal-data",
    },
    {
      path: "/my-preferences",
      description: "Preferencias",
      private: true,
      showHeader: true,
      breadcrumbList: [
        { name: t('breadcrumb.myProfile'), href: "/my-profile" },
        { name: t('breadcrumb.preferences'), href: "/my-preferences" },
      ],
    },
    {
      path: "/plan",
      description: "Planificar viaje",
      private: true,
      showHeader: true,
    },
    {
      path: "/trip",
      description: "Planificar ida",
      private: true,
      showHeader: true,
    },
    {
      path: "/trip-train",
      description: "Planificar tren ida",
      private: true,
      showHeader: true,
    },
    {
      path: "/confirm-planing",
      description: "Confirmar Planificacion",
      private: true,
      showHeader: true,
    },
    {
      path: "/register-user-ATC",
      description: "Flujo de registro ATC",
      private: false,
      showHeader: true,
      exitInternalPathBack: "/",
    },
    {
      path: "/return-ave",
      description: "Viaje de vuelta de flujo IDAYVUELTA de Ave",
      private: true,
      showHeader: true,
    },
    {
      path: "/detail-activy",
      description: "Detalle TMB",
      private: true,
      showHeader: true,
    },
    {
      path: "/passengers",
      description: "Pasajeros TMB",
      private: true,
      showHeader: true,
    },
    {
      path: "/tmb-night-bus-flow",
      description: "Compra TMB",
      private: true,
      showHeader: true,
    },
    {
      path: "/tmb-normal-flow",
      description: "Compra TMB - Normal",
      private: true,
      showHeader: true,
    },
    {
      path: "/tmb-resume-route",
      description: "Pantalla de resumen pago TMB",
      private: true,
      showHeader: true,
    },
    {
      path: "/tmb-confirm-planning",
      description: "Confirmar Planificacion TMB",
      private: true,
      showHeader: true,
    },
    {
      path: "/activity-management",
      description: "Gestión de actividades",
      private: true,
      showHeader: true,
    },
    {
      path: "/planTrain",
      description: "Planificador trenes",
      private: true,
      showHeader: true,
    },
    {
      path: "/activity-confirm-planning",
      description: "Confirmar Planificacion Actividad",
      private: true,
      showHeader: true,
    },
    {
      path: "/my-documents",
      description: "Mis documentos",
      private: true,
      showHeader: true,
      breadcrumbList: [
        { name: t('breadcrumb.myProfile'), href: "/my-profile" },
        { name: t('breadcrumb.myDocuments'), href: "/my-documents" },
      ],
    },
    {
      path: " /QRVeridas",
      description: "QR Veridas",
      private: true,
      showHeader: true,
    },
     {
      path: "/permissions",
      description: "Permisos",
       private: true,
      showHeader: true,
         breadcrumbList: [
        { name: t('breadcrumb.myProfile'), href: "/my-profile" },
        { name: t('breadcrumb.permissions'), href: "/permissions" },
      ],
    },



  ];
}
